jQuery( document ).ready(function( $ ) {
  setTimeout(()=> {
$('a[data-pid="43700947517683"]').removeClass('add_to_cart_button').removeClass('ajax_add_to_cart').text('Read More').find('.basel-tooltip-label').text('Read More');
}, 00);

// update subscription widget text 'bsub-widget__text'
const elements = document.querySelectorAll('.bsub-widget__text');

elements.forEach(element => {
  // Use regex to find the number of months and orders in the text
  const matches = element.textContent.match(/(\d+)\sorders/);

  if (matches) {
    // If there's a match, construct the new text with the number of months
    const numMonths = matches[1]; // This is the number of months/orders
    element.textContent = `Prepaid ${numMonths} Months`;
  } else if (element.textContent === 'Prepaid Months') {
    // If the text is exactly "Prepaid Month", change it to "1 Month"
    element.textContent = 'Monthly Subscription';
  }
});
});